import React from "react";
import moment from "moment";

interface PayrollUploadResponseProps {
  data: {
    totalRecords: number;
    processed: number;
    errors: number;
    processedEmails: string[];
    errorEmails: string[];
    month: string;
    country: string;
    error?: string;
  } | null;
}

function PayrollUploadResponse({ data }: PayrollUploadResponseProps) {
  if (!data) return null;

  const { totalRecords, processed, errors, processedEmails, errorEmails, month, country } = data;

  if (data.error) {
    return <div className="text-error">{data.error}</div>;
  }

  return (
    <>
      <h2 className="heading-h2-semibold mb-1">Payroll Upload Summary</h2>
      <div className="flex flex-wrap gap-1 mb-1">
        <div className="para-body-s-regular">
          <strong>Month:</strong> {moment(month).format("MMMM YYYY")}
        </div>
        <div className="para-body-s-regular">
          <strong>Country:</strong> {country}
        </div>
        <div className="para-body-s-regular">
          <strong>Total Records:</strong> {totalRecords}
        </div>
        <div className="para-body-s-regular">
          <strong>Processed:</strong> {processed}
        </div>
        <div className="para-body-s-regular">
          <strong>Errors:</strong> {errors}
        </div>
      </div>
      <div>
        <h3 className="heading-h4-semibold text-error mb-05">Associates with missing data ({errorEmails.length})</h3>
        <div className="border rounded px-125 py-025 bg-white">
          <ul className="m-0 p-0">
            {errorEmails.map((email) => (
              <li key={email} className="para-body-s-regular text-error font-bold">
                {email}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="mb-1">
        <h3 className="heading-h4-semibold mb-05">Processed associates ({processedEmails.length})</h3>
        <div className="border rounded px-125 py-025 bg-white">
          <ul className="m-0 p-0">
            {processedEmails.map((email) => (
              <li key={email} className="para-body-s-regular">
                {email}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
}

export default PayrollUploadResponse;
